import { render, staticRenderFns } from "./codes-list.vue?vue&type=template&id=a97213e6"
import script from "./codes-list.vue?vue&type=script&lang=js"
export * from "./codes-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports